module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAKlBMVEUAAABZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGp6spkjAAAADXRSTlMA1w8Wxh7dzL69MRq//EO/gAAAAC1JREFUCNdjWGHAwMAwVxhIqF/cwMDA5CsKZKpcC2BgYL57AMwCiYFlIerAOgA6Xwtd5MfYFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_next_hover.png
// module id = iGZD
// module chunks = 9